import { modelT } from "../../redux/features/ui/ui.types";

export const modelsBedroomPresets: modelT[] = [
  {
    img: "/images/assets/CollectionImages/bed-bessteller-4.png",
    imageLabel: "bed-bestseller-4",
    label: "Queen",
    labelUI: "Queen Modern",
    configurationShortId: "qYjPlY9Em",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-3.png",
    imageLabel: "bed-bestseller-3",
    label: "Queen",
    labelUI: "Queen Classic",
    configurationShortId: "wLEfdp2J5",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-1.png",
    imageLabel: "bed-bestseller-1",
    label: "Queen",
    labelUI: "Queen Classic with End Drawers",
    configurationShortId: "GXhk2NhAR",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-2.png",
    imageLabel: "bed-bestseller-2",
    label: "Queen",
    labelUI: "Eastern King Luxe With End Drawers",
    configurationShortId: "V256TgtMA",
    subcategory: "Rails",
  },
];
